/**
 * 청소년보호정책 페이지 (호주 법률 준수)
 */

import Seo from "@/components/seo/Seo";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Shield, AlertTriangle, Users } from "lucide-react";

export default function Youth() {
  return (
    <>
      <Seo
        title="청소년보호정책 — OZK News"
        description="OZK News 청소년보호정책"
        path="/youth"
      />

      <div className="min-h-screen bg-background">
        <div className="max-w-4xl mx-auto px-4 py-12">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold mb-4">청소년보호정책</h1>
            <p className="text-lg text-muted-foreground">
              호주 청소년이 안전하게 인터넷을 이용할 수 있도록
            </p>
          </div>

          <Alert className="mb-6">
            <Shield className="h-4 w-4" />
            <AlertDescription>
              본 정책은 호주 청소년 보호법 및 eSafety 규정을 준수합니다.
            </AlertDescription>
          </Alert>

          <div className="space-y-6">
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <AlertTriangle className="w-5 h-5" />
                  유해 콘텐츠 차단
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <p className="text-muted-foreground">
                  OZK News는 청소년에게 유해한 콘텐츠를 차단하고 관리합니다.
                </p>
                <ul className="list-disc list-inside space-y-1 text-muted-foreground">
                  <li>욕설, 폭력, 음란성 콘텐츠 자동 필터링</li>
                  <li>관리자 검토 및 수동 삭제</li>
                  <li>신고 시스템을 통한 신속한 대응</li>
                </ul>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Users className="w-5 h-5" />
                  댓글 및 커뮤니티 관리
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <p className="text-muted-foreground">
                  안전한 커뮤니티 환경을 위해 다음 조치를 시행합니다:
                </p>
                <ul className="list-disc list-inside space-y-1 text-muted-foreground">
                  <li>로그인 사용자만 댓글 작성 가능</li>
                  <li>부적절한 댓글 자동 필터링 및 삭제</li>
                  <li>신고 접수 시 24시간 내 조치</li>
                </ul>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>신고 제도</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <p className="text-muted-foreground">
                  유해 콘텐츠를 발견하신 경우 즉시 신고해 주세요.
                </p>
                <p className="text-muted-foreground">
                  신고는 <a href="/support" className="text-brand-primary hover:underline">고객센터</a>를 통해 접수하실 수 있습니다.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>청소년 보호 책임자</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground">
                  이메일:{" "}
                  <a
                    href="mailto:ozknews.com@gmail.com"
                    className="text-brand-primary hover:underline"
                  >
                    ozknews.com@gmail.com
                  </a>
                </p>
                <p className="text-sm text-muted-foreground mt-2">
                  청소년 보호 관련 문의사항은 위 이메일로 연락 주시기 바랍니다.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
}
